import { Pipe, PipeTransform } from "@angular/core";

import { EXPAND_KEY } from "../constants/EXPAND_KEY";

@Pipe({
  name: "visibleExpandRow",
})
export class VisibleExpandRowPipe implements PipeTransform {
  transform(row: Record<string, any>): boolean {
    return row[EXPAND_KEY];
  }
}
